import * as components from './src';

export default components;